import View from './view';

import { hashify } from '../utils/arrays';

export default View.extend( {
    
    className: 'grid-toolbar',
    
    initialize(options = {}) {
        View.prototype.initialize.call( this, options );

        // extract actual labels from "actionLabels" hash parameter:
        // $edit="hello, i am example of button label for task EDIT"
        const {actionList} = options;
        let {actionLabels} = options;
        const actionLabelKeys = Object.keys( actionLabels )
            .filter( key => key.startsWith( '$' ) )
            .map( key => key.substr( 1 ) );
        actionLabels = hashify( actionLabelKeys, key => [key, actionLabels[`$${key}`]] );

        // get copy of action data
        this.actions = hashify( Object.keys( actionList.actions ),
            actionCode => {
                const actionDataCopy = actionList.actions[actionCode];
                return [actionCode, { 
                    ...actionDataCopy, 
                    name: actionLabels[actionCode] || actionDataCopy.name }
                ];
            } );

        actionList.plug( this );
        // when occurs update of actions' state,
        // update buttons in toolbar (enabled/disabled state)
        this.listenTo( actionList, 'update', () => 
            this.render( this.serialize( {} ) ) );
    },
    
    events: {
        
        'click button': function(e) {
            // action code stored in data-action attribute
            // (see toolbar.handlebars)
            this.trigger( `action:${e.target.dataset.action}` );
        }
        
    },
    
    serialize() {
        const actions = Object.keys( this.actions ).map( actionName => {
            let action = this.actions[actionName],
                { code, name, disabled, defaults } = action;
            
            // check enability of button
            // using "disabled" property of
            // button definition
            if ('function' === typeof disabled) 
                disabled = disabled();
                
            return { code, name, disabled, defaults };
        } );
        
        return { actions };
    }
    
}, {
    
    of(options) {
        const Class = this;
        return new Class( options );
    }
    
} );


// WEBPACK FOOTER //
// ./src/js/view/toolbar.js